module.exports = __webpack_public_path__ + "static/media/45_Shoaei_webfinal.8406ef09.jpg";